
import Common from '/common.jsx';
import { style } from 'glamor'
import { createRef } from 'preact';
import {Pie} from 'react-chartjs-2';
import 'chart.js/auto'; // ADD THIS

var testdata = {
    labels: ['Red', 'Blue', 'Yellow', 'Green', 'Purple', 'Orange'],
    datasets: [
      {
        label: '# of Votes',
        data: [12, 19, 3, 5, 2, 3],
        backgroundColor: [
          'rgba(255, 99, 132, 0.2)',
          'rgba(54, 162, 235, 0.2)',
          'rgba(255, 206, 86, 0.2)',
          'rgba(75, 192, 192, 0.2)',
          'rgba(153, 102, 255, 0.2)',
          'rgba(255, 159, 64, 0.2)',
        ],
        borderColor: [
          'rgba(255, 99, 132, 1)',
          'rgba(54, 162, 235, 1)',
          'rgba(255, 206, 86, 1)',
          'rgba(75, 192, 192, 1)',
          'rgba(153, 102, 255, 1)',
          'rgba(255, 159, 64, 1)',
        ],
        borderWidth: 1,
      },
    ],
  };

export default class GraphWindow extends Common {

pieRef = createRef();
componentDidMount() {
  const that = this;
  
  setInterval(() => {
    const {data} = this.props;
    const chart = that.pieRef.current;
    chart.data = data;
    chart.update();
  }, 1000); 
}

render(){

const {data} = this.props;
if (data.datasets) {
//if (data.datasets[0].data[0] > 0) {
  //console.log(data);
  return(
  <div {...styles.div}>
  <h2># Locations Visited</h2>
  <Pie data={data} ref={this.pieRef}/>
  </div>
  );
//}
}
}
}
const col_bg = 'rgb(28, 17, 37)';
const drawer_size = 35;
const styles = {
  
    div: style({
        backgroundColor: 'color(0,0,0,0)',
        position: 'absolute',
        bottom: '10%',
        left: '0',
        height: `${drawer_size}vh`,
        transition: 'transform 0.5s ease',
        overflowY: 'visible',
        margin: '0 2vw',
        padding: '0 2vw',
    }),
}